import React from 'react';

import Spinner from 'ui-library/Spinner';
import copyToClipboard from 'util/clipboard/copyToClipboard';

interface DocumentPartApiIdLabelProps {
  /** Null while the note part's document part is being created by a save. */
  apiId: string | null;
}

export default function DocumentPartApiIdLabel({apiId}: DocumentPartApiIdLabelProps): JSX.Element {
  if (apiId == null) {
    return (
      <div className="text-right mediocre-row-apiIdWrapper">
        <Spinner aria-label="Saving" classNames="mediocre-row-apiIdSpinner" />
      </div>
    );
  }
  return (
    <div className="text-right mediocre-row-apiIdWrapper">
      <button
        type="button"
        className="btn-link mediocre-row-apiId u-ellipsis-text"
        title={`${apiId} (click to copy)`}
        // Keeps the click from changing the editor selection.
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        onClick={() => copyToClipboard(apiId, {showToastOnSuccess: true})}
      >
        {apiId}
      </button>
    </div>
  );
}
